const US_FLAG = "\uD83C\uDDFA\uD83C\uDDF8";

const FLAG_REPLACEMENTS = {
  [US_FLAG]: {
    alt: "United States flag",
    src: "/flags/us.svg",
  },
};

export default function FlagEmojiText({ value, className = "" }) {
  const text = String(value || "");
  const tokens = Object.keys(FLAG_REPLACEMENTS);

  if (!tokens.some((token) => text.includes(token))) {
    return <>{text}</>;
  }

  const pieces = [];
  let remaining = text;
  let index = 0;

  while (remaining) {
    const next = tokens
      .map((token) => ({ token, position: remaining.indexOf(token) }))
      .filter((match) => match.position >= 0)
      .sort((a, b) => a.position - b.position)[0];

    if (!next) {
      pieces.push(remaining);
      break;
    }

    if (next.position > 0) {
      pieces.push(remaining.slice(0, next.position));
    }

    pieces.push(next.token);
    remaining = remaining.slice(next.position + next.token.length);
  }

  return (
    <>
      {pieces.map((piece, pieceIndex) => {
        const replacement = FLAG_REPLACEMENTS[piece];
        if (!replacement) {
          return <span key={`${pieceIndex}-${index++}`}>{piece}</span>;
        }

        return (
          <img
            key={`${pieceIndex}-${index++}`}
            src={replacement.src}
            alt={replacement.alt}
            className={`mx-1 inline-block h-[0.85em] w-[1.25em] align-[-0.05em] rounded-[2px] object-cover shadow-sm ${className}`}
            draggable="false"
          />
        );
      })}
    </>
  );
}
